<template>
    <div>
        <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="addSMSPopup"
      :class="{ show: addSMSPopup }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>SMS Message</h4>
          <button @click.stop="closePopup" class="close-modal">
            &times;
          </button>
        </div>
        <form
          style="height: auto; max-height: calc(100vh - 100px)"
          class="modal-content"
        >
          <div class="p-4">
            <vs-textarea placeholder="Enter text" v-model="smsBody" class="w-full" />
          </div>
          <div class="light_blue_holder p-4">
            <div style="padding-left: 100px" class="flex flex-wrap py-2">
              <vs-checkbox v-model="staffChecked">Staffs</vs-checkbox>
              <vs-checkbox v-model="parentsChecked">Parents</vs-checkbox>
              <vs-checkbox v-model="studentsChecked">Students</vs-checkbox>
            </div>
             <!-- for staff -->
             <div class="inline-flex w-full py-2" v-if="staffChecked">
                <label style="min-width: 100px">Staffs</label>
                <v-select
                  :getOptionLabel="
                    (item) => `${item.first_name} ${item.last_name}`
                  "
                  class="bg_white w-full"
                  placeholder="Staffs"
                  v-model="teacher_ids"
                  :options="teacherList"
                  :reduce="(teacher) => teacher.users_id"
                  label="name"
                  @open="onOpenTeacher"
                  @close="onCloseTeacher"
                  multiple
                >
                  <template v-slot:selected-option="teacherList">
                    <img
                      v-if="teacherList.picture"
                      class="person-img rounded-full"
                      :src="teacherList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ teacherList.first_name }}
                    {{ teacherList.last_name }}
                  </template>
                  <template v-slot:option="teacherList">
                    <img
                      v-if="teacherList.picture"
                      class="person-img rounded-full"
                      :src="teacherList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ teacherList.first_name }}
                    {{ teacherList.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadTeacher"
                      class="loader"
                      v-show="teacher_meta.has_next"
                    >
                      Loading more staffs...
                    </li>
                  </template>
                </v-select>
              </div>
              <!-- for parents -->
              <div class="inline-flex w-full py-2" v-if="parentsChecked">
                <label style="min-width: 100px">Parents</label>
                <v-select
                  :getOptionLabel="
                    (item) => `${item.first_name} ${item.last_name}`
                  "
                  class="bg_white w-full"
                  placeholder="Parents"
                  v-model="parents_ids"
                  :options="parentlist"
                  :reduce="(parent) => parent.client_users_id"
                  label="name"
                  @open="onOpenParent"
                  @close="onCloseParent"
                  multiple
                >
                  <template v-slot:selected-option="parentlist">
                    <img
                      v-if="parentlist.picture"
                      class="person-img rounded-full"
                      :src="parentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ parentlist.first_name }}
                    {{ parentlist.last_name }}
                  </template>
                  <template v-slot:option="parentlist">
                    <img
                      v-if="parentlist.picture"
                      class="person-img rounded-full"
                      :src="parentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ parentlist.first_name }}
                    {{ parentlist.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadParent"
                      class="loader"
                      v-show="parent_meta.has_next"
                    >
                      Loading more parents...
                    </li>
                  </template>
                </v-select>
              </div>
              <!-- for students -->
              <div class="inline-flex w-full py-2" v-if="studentsChecked">
                <label style="min-width: 100px">Students</label>
                <v-select
                  :getOptionLabel="
                    (item) => `${item.first_name} ${item.last_name}`
                  "
                  class="bg_white w-full"
                  placeholder="Students"
                  v-model="student_ids"
                  :options="studentlist"
                  :reduce="(student) => student.client_users_id"
                  label="name"
                  @open="onOpenStudent"
                  @close="onCloseStudent"
                  multiple
                >
                  <template v-slot:selected-option="studentlist">
                    <img
                      v-if="studentlist.picture"
                      class="person-img rounded-full"
                      :src="studentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ studentlist.first_name }}
                    {{ studentlist.last_name }}
                  </template>
                  <template v-slot:option="studentlist">
                    <img
                      v-if="studentlist.picture"
                      class="person-img rounded-full"
                      :src="studentlist.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ studentlist.first_name }}
                    {{ studentlist.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      ref="loadStudent"
                      class="loader"
                      v-show="student_meta.has_next"
                    >
                      Loading more students...
                    </li>
                  </template>
                </v-select>
              </div>
          </div>
        </form>
        <vs-divider />
        <div class="p-4 pt-0">
          <vs-button class="block ml-auto" @click="sendSMS">Send SMS</vs-button>
        </div>
      </div>
    </div>
    </div>
</template>
<script>
import { fetchUserClient } from '@/api/task-project.js'
import vSelect from 'vue-select'
import {
  sendSMS } from '@/api/communication'

export default {
  props:{
    addSMSPopup:{
      default:true
    }
  },
  components:{
    vSelect
  },
  data () {
    return {
      from_user_type:'1',
      sendSMSToUsers:[],
      staffChecked: false,
      parentsChecked: false,
      studentsChecked: false,
      smsBody:'',
      studentlist: [],
      teacherList: [],
      parentlist: [],
      teacher_ids: [],
      student_ids: [],
      parents_ids: [],
      observerStudent: new IntersectionObserver(this.loadMoreStudents),
      observerParents: new IntersectionObserver(this.loadMoreParents),
      observerTeacher: new IntersectionObserver(this.loadMoreStaff),
      parent_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      student_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      customer_id:localStorage.getItem('customer_id')
      
    }
  },
  watch: {
    studentsChecked () {
      if (this.studentsChecked) {
        this.fetchStudentList()
      } else {
        this.student_ids = []
      }
    },
    parentsChecked () {
      if (this.parentsChecked) {
        this.fetchParentList()
      } else {
        this.parents_ids = []
      }
    },
    staffChecked () {
      if (this.staffChecked) {
        this.getTeacherList()
      } else {
        this.teacher_ids = []
      }
    }
  },
  methods: {
    closePopup () {
      this.addSMSPopup = false
      this.$emit('closeSmsPopup', true)
    },
    async loadMoreStaff () {
      try {
        const payload = {
          ...this.filterPayload
        }
        this.teacher_meta.page = this.teacher_meta.page + 1

        const data = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList.push(...data.data.data.users_list)
        this.teacher_meta = data.data.data.meta
        this.teacher_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    async getTeacherList () {
      try {
        const payload = {
          ...this.filterPayload
        }

        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async loadMoreParents () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['parent']
        }
        this.parent_meta.page = this.parent_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist.push(...data.data.data.users_list)
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async onOpenParent () {
      if (this.parent_meta.has_next) {
        await this.$nextTick()
        this.observerParents.observe(this.$refs.loadParent)
      }
    },
    onCloseParent () {
      this.observerParents.disconnect()
    },
    async fetchParentList () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['parent']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.parent_meta,
          payload
        )
        this.parentlist = data.data.data.users_list
        this.parent_meta = data.data.data.meta
        this.parent_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async loadMoreStudents () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['children', 'individual']
        }
        this.student_meta.page = this.student_meta.page + 1

        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist.push(...data.data.data.users_list)
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async fetchStudentList () {
      try {
        const payload = {
          ...this.filterPayload,
          type: ['children', 'individual']
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.student_meta,
          payload
        )
        this.studentlist = data.data.data.users_list
        this.student_meta = data.data.data.meta
        this.student_meta.page = data.data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenStudent () {
      if (this.student_meta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observerStudent.disconnect()
    },
    getSelectedRecipientObject (selected_recipient, to_user_type, is_root_user) {
      for (let i = 0; i < selected_recipient.length; i++) {
        this.sendSMSToUsers.push({
          to_user_id: selected_recipient[i],
          to_user_type,
          is_root_user
        })
      }
    },
    async sendSMS () {

      //To Recipients
      if (this.studentsChecked) {
        this.getSelectedRecipientObject(this.student_ids, 3, true)
      }
      if (this.parentsChecked) {
        this.getSelectedRecipientObject(this.parents_ids, 2, true)
      }
      if (this.staffChecked) {
        this.getSelectedRecipientObject(this.teacher_ids, 1, true)
      }
      const payload = {  
        'from_user_type':this.from_user_type,
        'is_parent_thread':true,
        'body': this.smsBody,
        'to_users': this.sendSMSToUsers
      }

      try {
        //this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        // eslint-disable-next-line no-unused-vars
        const data = await sendSMS(customer_id, payload)
        this.$emit('closeSmsPopup', true)
        this.clearComposeSMS()

        this.$vs.notify({
          title: 'Success',
          text: 'SMS Sent Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
  
        let errorText = ''
        if (error.data.errors.body) {
          errorText = 'Body is required'
        } else if (error.data.errors.to_users) {
          errorText = 'To users is required'
        }
  
        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } finally {
        //this.$vs.loading.close()
      }
    },
    clearComposeSMS () {
      this.from_user_type = '1'
      this.smsSubject = ''
      this.smsBody = ''
      this.student_ids = []
      this.parents_ids = []
      this.teacher_ids = []
      this.client_recipient = false
      this.sendSMSToUsers = []
      this.smsSidebar = false
    }
  }
}
</script>